<template>
    <div>
        <modal :show.sync="show" :large="true">
            <div class="modal-header"
                 slot="modal-header">
                <h4>Sélectionner le profil avec lequel fusionner</h4>
            </div>

            <div class="modal-body"
                 slot="modal-body">
                <div class="search-area">
                    <div class="search-row f -a-center">
                        <div class="form-group expand">
                            <label for="clients-search"
                                   class="sr-only">
                                Chercher un membre
                            </label>
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <loader v-show="loading"></loader>
                                    <i v-show="!loading" class="glyphicon glyphicon-search"></i>
                                </div>
                                <input type="text"
                                       class="form-control"
                                       id="clients-search"
                                       v-model="searchQuery"
                                       placeholder="Chercher un nom, un numéro de téléphone, etc"
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <table class="table table-hover -clients -row-links">
                    <tr>
                        <th>Nom</th>
                        <th>Status</th>
                        <th>Sources</th>
                        <th>Carac.</th>
                        <th>Risque</th>
                        <th>Projets</th>
                        <th class="number-col">C. init.</th>
                        <th class="number-col">Versements</th>
                    </tr>

                    <tr v-for="client in clients" v-show="!loading">
                        <td class="name-col">
                            {{ client.name }}
                        </td>
                        <td class="right-col">
                            <span v-if="client.status === 'client'">membre</span>
                            <span v-if="client.status === 'prospect'">prospect</span>
                            <small v-if="client.active">(actif)</small>
                        </td>
                        <td class="right-col">
                            <span v-for="source in client.sources">
                                <span v-if="source === 'alpinia'">AF</span>
                                <span v-if="source === 'activeseed'">AS</span>
                            </span>
                        </td>
                        <td class="right-col">
                            {{ adjective(client) }}
                        </td>
                        <td class="right-col">
                            {{ asProfile(client) }}
                        </td>
                        <td class="right-col">
                            <span class="badge"
                                  v-for="plan of lifePlans(client)">
                                {{ plan }}
                            </span>
                        </td>
                        <td class="right-col number-col">
                            {{{ client.capital | money }}}
                        </td>
                        <td class="right-col number-col">
                            {{{ client.payment | money }}}
                        </td>
                        <td class="right-col button-col">
                            <button
                                :disabled="client.id === clientToMergeWith.id"
                                class="btn btn-info -select-client-btn"
                                @click="selectClient(client)">
                                Sélectionner
                            </button>
                        </td>
                    </tr>
                </table>
                <loader v-show="loading" class="bigger-loader"></loader>

                <div class="load-more">
                    <a href="#"
                       v-if="hasNext && !loading"
                       v-on:click.prevent="updateList(true)"
                       class="btn btn-default">
                        Charger plus
                    </a>
                </div>
            </div>

            <div slot="modal-footer" class="modal-footer cta">
                <a class="btn btn-default"
                   @click.prevent="show = false">
                    Annuler
                </a>
            </div>
        </modal>
    </div>
</template>

<style lang="less" type="text/less" scoped>
    .load-more {
        text-align: center;
    }
    tr {
        .button-col {
            vertical-align: middle;
        }
        .-select-client-btn {
            visibility: hidden;
            color: #fff !important;
            text-decoration: none;
        }
        &:hover {
            .-select-client-btn {
                visibility: visible;
            }
        }
        td {
            vertical-align: middle;
        }
    }
</style>

<script>
    import Loader from '../../components/Loader';
    import Modal from 'vue-strap/src/Modal';
    import {getAdjectiveDisplay, list} from '../../api/client';
    import {lifePlans, makeUpdateList} from '../../utils';

    export default {
        components: {
            Loader,
            Modal
        },
        name: 'select-client-modal',
        props: {
            onSelect: Function
        },
        data() {
            return {
                clientToMergeWith: {},
                hasNext: false,
                show: false,
                clients: [],
                loading: false,
                sources: []
            };
        },
        ready() {
            this.updateList();
        },
        watch: {
            searchQuery() {
                this.updateList();
            }
        },
        methods: {
            lifePlans: lifePlans,
            /**
             * Returns a displayable adjective for this client
             */
            adjective(client) {
                if (!client ||
                    !client.activeseed ||
                    !client.activeseed.adjective) {
                    return '';
                }

                return getAdjectiveDisplay(client.activeseed.adjective);
            },

            /**
             * Format the AS risk profile
             */
            asProfile(client) {
                const profile = client &&
                    client.activeseed &&
                    client.activeseed.as_profile;

                if (profile) {
                    return profile.replace('_', ' - ');
                }

                return '';
            },
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'clients',
                fetch: async function (page) {
                    const selection = (this.clientToMergeWith.activeseed !==
                        null) ? {
                            is_as: false
                        } : {};
                    return await list(
                        this.searchQuery,
                        [
                            {
                                name: 'is_as',
                                param: 'is_as',
                                type: 'enum',
                                values: [false, true]
                            }
                        ],
                        selection,
                        page
                    );
                }
            }),
            /**
             * Show the select contracts modal and close this one
             */
            selectClient(client) {
                this.show = false;
                this.onSelect(client);
            }
        },
        events: {
            'client-merge': function (sources, client) {
                this.clientToMergeWith = client;
                this.sources = sources;
                this.updateList();
                this.show = true;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// SelectClientModal.vue?01e6e3f4